import style from './technologies.module.scss'
import { ISectionsTech, ITechnologyState, TechnologyState } from './technologies.state';
import PreviewSection from './preview.section'
import TechnologiesNavbar from '@components/expertise/technologies/technologies-navbar';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';

const TechnologyComponent = () => {
    const { pageTitle, pageSubtitle, sections, sectionLinks }: ITechnologyState = TechnologyState;

    const reversedSection = (index: number): boolean => index % 2 !== 0;

    return (
        <>
            <Breadcrumbs lastElementTitle={'technologies'}/>
            <div className={style.wrapper}>
                <TechnologiesNavbar links={sectionLinks}/>
                <div className={style.head__container}>
                    <h1 className={style.head__title}>{pageTitle}</h1>
                    <h3 className={style.head__description}>{pageSubtitle}</h3>
                </div>
                {sections.map((item: ISectionsTech, index: number) => (
                    <PreviewSection key={item.title} section={item} reversed={reversedSection(index)}/>
                ))}
            </div>
        </>
    )
}

export default TechnologyComponent;
